<template>
    <div class="modal fade" tabindex="-1" id="ModalDetalhes">
        <div class="modal-dialog modal-dialog-centered modal-xl">
            <div class="modal-content border-0">
                <div class="modal-body">
                    <div class="py-4 px-4">
                        <h3 class="title">{{titulo}}</h3>
                        <hr />
                        <div class="componente px-3">
                            <template v-if="componente">
                                <component v-if="componente" :is="componente" :dados="dataResult" :busca="dados"></component>
                            </template>
                        </div>
                    </div>
                </div><!-- .modal-body -->
                <button class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3" data-bs-dismiss="modal">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                    </svg><!-- x-lg -->
                </button><!-- modal-close -->
            </div><!-- .modal-content -->
        </div><!-- .modal-dialog -->
    </div><!-- .modal -->
</template> 

<script>
    import viewACORD from '@/components/ModalReferencia/viewACORD'
    import viewBOLET from '@/components/ModalReferencia/viewBOLET'
    import viewJURIS from '@/components/ModalReferencia/viewJURIS'
    import viewSUMUL from '@/components/ModalReferencia/viewSUMUL'

    import viewLFSIS from '@/components/ModalReferencia/viewLFSIS'
    import viewLGEST from '@/components/ModalReferencia/viewLGEST'
    import viewLGFED from '@/components/ModalReferencia/viewLGFED'
    import viewLGMUN from '@/components/ModalReferencia/viewLGMUN'

    import viewACSTF from '@/components/ModalReferencia/viewACSTF'
    import viewJUSTF from '@/components/ModalReferencia/viewJUSTF'
    import viewBOSTF from '@/components/ModalReferencia/viewBOSTF'
    import viewSUSTF from '@/components/ModalReferencia/viewSUSTF'

    import { urlApi, avisoErro } from '@/config/global'
    import axios from 'axios'

    export default {
        name: 'ModalDetalhes',
        components: {
            viewACORD,
            viewBOLET,
            viewJURIS,
            viewSUMUL,

            viewLFSIS,
            viewLGEST,
            viewLGFED,
            viewLGMUN,

            viewACSTF,
            viewJUSTF,
            viewBOSTF,
            viewSUSTF
        },
        props: {
            dados: Object,
            showModal: Boolean,
            titulo: {
                type: String,
                default: 'Referências da pesquisa'
            },
        },
        data: function () {
            return {
                componente: null,
                dataResult: null,
            }
        },
        methods: {
            load() {
                let $this = this;
                axios.get(`${urlApi}/ConversaReferencia/view${$this.dados.cdConteudo}`, {
                    params: {
                        idItemPesquisa: $this.dados.idItemPesquisa,
                        dsReferencia: $this.dados.dsReferencia,
                        idLogPesquisa: $this.dados.idLogPesquisa,
                    }
                })
                    .then(res => {
                        if (res.data.success) {
                            if (res.data.data) {
                                $this.dataResult = res.data.data;
                                $this.componente = 'view' + $this.dados.cdConteudo;

                                const myModalAlternative = new window.bootstrap.Modal('#ModalDetalhes');
                                myModalAlternative.show();
                                
                            } else {
                                $this.dataResult = 'NotFound';
                            }
                        } else {
                            avisoErro("Não foi possível carregar view");
                            //console.log("Não foi possível carregar view");
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível carregar view");
                        //console.log("Não foi possível carregar view");
                    });
            },

            hideModalFn() {
                const myModalAlternative = new window.bootstrap.Modal('#ModalDetalhes');
                myModalAlternative.hide();
            },
        },
        mounted: function () {
            
        },
        watch: {
            showModal: function () {
                if (this.dados.cdConteudo != null && this.dados.cdConteudo != undefined && this.dados.cdConteudo != '') {
                    this.load();
                }
                
            },

        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
    
    .modal-titulo {
        padding-bottom: 20px;
        border-bottom: 2px solid #034471;
        display: flex;
        justify-content: space-between;
    }

    .modal-conteudo {
        overflow-y: auto;
        overflow-x: hidden;
        max-height: 68vh;
    }

    .btn-default {
        background: #767676;
        padding: 10px;
        border: 3px solid;
        border-color: #767676;
        color: #FFF;
        border-radius: 5px;
    }

    .btn-default:hover {
        background: #777777;
        border-color: #777777;
        color: #FFF;
    }
    .ModalDetalhes span, .ModalDetalhes li {
        color: #041A1C !important;
    }

    .componente .modal-conteudo {
        overflow-y: auto;
        max-height: 65vh;
    }

    
</style>

